import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    changeTransaction,
    setEdit,
    setInActiveEditingTransaction,
    setShowModal,
} from "../../features/transaction/transactionSlice";

const EditTransactionModal = () => {
    const [name, setName] = useState("");
    const [type, setType] = useState("income");
    const [amount, setAmount] = useState("");
    const dispatch = useDispatch();

    const { isLoading, editingTransaction, showModal } = useSelector(
        (state) => state.transaction
    );

    const {
        id,
        name: editingTName,
        type: editingTType,
        amount: editingTAmount,
    } = editingTransaction || {};

    useEffect(() => {
        if (id) {
            setName(editingTName);
            setType(editingTType);
            setAmount(editingTAmount);
        } else {
            resetInputs();
        }
    }, [editingTransaction, editingTName, editingTType, editingTAmount, id]);

    const resetInputs = () => {
        setName("");
        setType("");
        setAmount("");
    };

    const handleUpdate = (e) => {
        e.preventDefault();

        dispatch(
            changeTransaction({
                id,
                data: {
                    name,
                    type,
                    amount,
                },
            })
        );

        dispatch(setEdit(false));
        dispatch(setInActiveEditingTransaction());
        dispatch(setShowModal(false));
        resetInputs();
    };

    const handleCancelEdit = () => {
        dispatch(setShowModal(false));
        dispatch(setEdit(false));
        dispatch(setInActiveEditingTransaction());
        resetInputs();
    };

    return (
        <>
            <div className={`modal ${!showModal && "hidden"}`}>
                <button
                    onClick={handleCancelEdit}
                    className="btn__close__modal"
                >
                    &times;
                </button>
                <h2 className="modal__header">Edit Your Transaction</h2>
                <form onSubmit={handleUpdate}>
                    <div className="form-group">
                        <label>Name</label>
                        <input
                            type="text"
                            name="name"
                            required
                            placeholder="enter title"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </div>

                    <div className="form-group radio">
                        <label>Type</label>
                        <div className="radio_group">
                            <input
                                required
                                type="radio"
                                value="income"
                                name="type"
                                checked={type === "income"}
                                onChange={(e) => setType(e.target.value)}
                            />
                            <label>Income</label>
                        </div>
                        <div className="radio_group">
                            <input
                                type="radio"
                                value="expense"
                                name="type"
                                placeholder="Expense"
                                checked={type === "expense"}
                                onChange={(e) => setType(e.target.value)}
                            />
                            <label>Expense</label>
                        </div>
                    </div>

                    <div className="form-group">
                        <label>Amount</label>
                        <input
                            type="number"
                            placeholder="300"
                            required
                            name="amount"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                        />
                    </div>

                    <button
                        disabled={isLoading}
                        className="btn add_transaction_btn"
                        type="submit"
                    >
                        Update Transaction
                    </button>
                    <button
                        onClick={handleCancelEdit}
                        className="btn cancel_edit"
                    >
                        Cancel Edit
                    </button>
                </form>
            </div>
            <div
                onClick={handleCancelEdit}
                className={`overlay ${!showModal && "hidden"}`}
            ></div>
        </>
    );
};

export default EditTransactionModal;
